var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelefonoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 478,
    height: 478,
    viewBox: "0 0 478 478",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.009 380.316L472.634 373.16C467.009 356.441 448.572 339.004 431.634 334.41L368.946 317.285C351.946 312.66 327.696 318.879 315.258 331.316L292.57 354.004C210.117 331.724 145.461 267.066 123.211 184.629L145.9 161.94C158.338 149.502 164.556 125.284 159.931 108.284L142.837 45.565C138.212 28.596 120.743 10.159 104.056 4.59599L96.9001 2.18999C80.1811 -3.37301 56.3371 2.25299 43.9001 14.69L9.96211 48.659C3.89911 54.69 0.0241079 71.94 0.0241079 72.003C-1.16289 179.753 41.0871 283.565 117.305 359.784C193.336 435.815 296.759 478.003 404.196 477.097C404.758 477.097 422.508 473.284 428.571 467.252L462.509 433.314C474.946 420.878 480.571 397.035 475.009 380.316Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 477.156,
    height: 477.156,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefonoIcon);
export default __webpack_public_path__ + "static/media/telefono-icon.2866ac58a3c3f325f16b00b07885b776.svg";
export { ForwardRef as ReactComponent };